module.exports = __webpack_public_path__ + "img/android-chrome-192x192.954aa8e2.png";